import { useMediaQuery } from 'react-responsive';

const useIsMobile = () => {
  const isMobile = useMediaQuery({ maxWidth: 721 });
  return isMobile;
};

export default useIsMobile;
